import Konva from 'konva';
import * as state from '../state.js';
import { attachInteractive, pointerPos } from './_helpers.js';

let active = null;
let startX = 0;
let startY = 0;

const HEADS = {
  standard: { pointerLength: 14, pointerWidth: 12 },
  fancy: { pointerLength: 22, pointerWidth: 22 },
  curved: { pointerLength: 16, pointerWidth: 14, tension: 0.5 },
  double: { pointerLength: 14, pointerWidth: 12, pointerAtBeginning: true },
};

export const arrow = {
  id: 'arrow',
  defaultProps: { head: 'standard' },
  onPointerDown(engine) {
    const pos = pointerPos(engine);
    if (!engine.pointerInsideImage(pos)) return;
    startX = pos.x;
    startY = pos.y;
    const head = (state.get('toolDefaults').arrow?.head) ?? this.defaultProps.head;
    const opts = HEADS[head] ?? HEADS.standard;
    active = new Konva.Arrow({
      points: [startX, startY, startX, startY],
      stroke: state.get('selectedColor'),
      fill: state.get('selectedColor'),
      strokeWidth: state.get('strokeWidth'),
      lineCap: 'round',
      lineJoin: 'round',
      ...opts,
    });
    engine.contentLayer.add(active);
  },
  onPointerMove(engine) {
    if (!active) return;
    const pos = pointerPos(engine);
    active.points([startX, startY, pos.x, pos.y]);
    engine.contentLayer.batchDraw();
  },
  onPointerUp(engine) {
    if (!active) return;
    const [x1, y1, x2, y2] = active.points();
    if (Math.hypot(x2 - x1, y2 - y1) < 6) {
      active.destroy();
    } else {
      active.remove();
      attachInteractive(engine, active);
    }
    engine.contentLayer.batchDraw();
    active = null;
  },
  apply(node, prop, value) {
    if (prop === 'color') {
      node.stroke(value);
      node.fill(value);
    } else if (prop === 'strokeWidth') {
      node.strokeWidth(value);
    } else if (prop === 'head') {
      const opts = HEADS[value] ?? HEADS.standard;
      // setAttrs to swap pointerLength / pointerWidth / pointerAtBeginning /
      // tension cleanly, including unsetting keys absent from the new preset.
      node.setAttrs({
        pointerLength: opts.pointerLength ?? null,
        pointerWidth: opts.pointerWidth ?? null,
        pointerAtBeginning: opts.pointerAtBeginning ?? false,
        tension: opts.tension ?? 0,
      });
    }
  },
};
